<template>
	<div class="flight-list">
		<template v-for="(flightItem,flightIndex) in flightListCopy">
			<flight-item 
			v-show="!flightItem.isNoShow"
			:key="flightItem.flightNo" 
			:flightIndex ="flightIndex"
			:flightItem="flightItem"
			:priceMap="priceMap"
			:chooseFlight="chooseFlight"
			@flightZhanKai="flightZhanKai"
			@cabinTypeZhanKai="cabinTypeZhanKai"
			@chooseFlight="toChooseFlight"
			:tkQuery="tkQuery"
			></flight-item>
		</template>
	</div>
</template>

<script>
    import tkCommon from '@/views/tk/tkCommon/tkCommon';
	import FlightItem from './FlightItem'
	export default{
		data(){
			return {
				flightListCopy:[],
			}
		},
		components:{
			FlightItem,
		},
		props:{
			flightList:{
				type:[Array],
				default (){
					return []
				}
			},
			flightMap:{
				type:[Object],
				default (){
					return {}
				}
			},
			priceMap:{
				type:[Object],
				default (){
					return {}
				}
			},
			planeMap:{
				type:[Object],
				default (){
					return {}
				}
			},
			// 选中的去程
			chooseFlight:{
				type:[Object],
				default (){
					return {}
				}
			},
			// 机票查询页问题
			tkQuery:{
				type:[Object],
				default (){
					return {}
				}
			}
		
			
		},
		watch:{
			flightList: {
			    handler (val, oldVal) {
					// console.log(val)
			     this.flightListCopy = this.$common.deepCopy(val)
			    },
			    deep: true,
				immediate: true, // 立即执行
			  },
			
		
		},
		mounted(){
			
			// this.flightListCopy = this.$common.deepCopy(this.flightList)
		},
		methods:{
			// 获取舱位详情
			getFlightMorePriceList(obj,callBack){
				
				let {flightItem,flightIndex,attrName,bool} = obj;


				// ✅ 1. 先检查是否已有缓存数据
				if (flightItem._cabinLoaded && flightItem[attrName] === bool) {
					// 如果已经加载过且状态相同，直接返回
					callBack && callBack(obj);
					return;
				}

				let queryString = {
					"cacheId": flightItem.cacheId,
					"flightNo": flightItem.flightNo,
					'tripType': this.tkQuery.tripType
				}
				var queryFlightUrl ='tkQuery2023.queryFlightCabin2';
				this.$conn.getConn(queryFlightUrl,{loading:false})(queryString,(res) => {
					
					let data = res.data || {};
					let  { flight = {} ,plane = {},priceMap = {} } = data;
					// 将 航班信息、机型、价格map
					flightItem = {
						...flightItem,
						...flight,
						...plane,
						_cabinLoaded: true, // 标记已加载
					}
					

					// 将新的舱位 生成价格列表
					flightItem = tkCommon.getFlightItemDetail(flightItem,priceMap,this.planeMap, this.flightMap,this.tkQuery)
					// ✅ 3. 使用 Vue.set 正确更新数组
					this.$set(this.flightListCopy,flightIndex,flightItem)
					 // ✅ 4. 如果是展开操作，延迟执行回调避免阻塞渲染
					 if (bool) {
						this.$nextTick(() => {
							callBack && callBack(obj);
						});
					} else {
						callBack && callBack(obj);
					}	
				},(err) => {
					this.$alert(err.tips, {
						confirmButtonText: '重新查询航班',
						callback: action => {
							this.$emit('reQuery',true)
						}
					});
				})
			},

			// 展开或者收缩某一个航班的舱位等级
			flightZhanKai(obj){
				
				this.getFlightMorePriceList(obj,(result)=>{
					this.$set(this.flightListCopy[result.flightIndex],result.attrName,result.bool)
				})
				
			},
			// 展开或者收缩某一个航班的某一个舱位等级的舱位和价格
			cabinTypeZhanKai(obj){
				this.$set(this.flightListCopy[obj.flightIndex]['cabinTypeList'][obj.cabinTypeIndex],obj.attrName,obj.bool)
				// this.$forceUpdate()
			},
			// 选择航班中的某一个价格
			toChooseFlight(flightItem){
				
				this.$emit('chooseFlight',flightItem)
			},
			
		}
	}
</script>

<style lang="scss">
	.flight-list{
		background-color: white;
		
	}
</style>
